import { render, staticRenderFns } from "./IconSvgStarEmpty.vue?vue&type=template&id=4120a632&scoped=true&"
import script from "./IconSvgStarEmpty.vue?vue&type=script&lang=js&"
export * from "./IconSvgStarEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120a632",
  null
  
)

export default component.exports